import { call, put } from 'redux-saga/effects';
import { sendError } from '../../../';
import api from '../../../../api-new/http';
import { appUrls } from '../../../../api-new/urls';
import { signUpData, signUpError, SignUpFetch, signUpRequireVerification } from '../actions';

export function* signUpSaga(action: SignUpFetch) {
    try {
        const { email, password, firstName, lastName, cic, dob, gender, campus } = action.payload;
        const userData = {
            fullName: `${firstName} ${lastName}`,
            password,
            email,
            cic,
            dob,
            gender,
            campus
        };
        yield call(() => api.post(`${appUrls.authenURL}/register`, userData));
        yield put(signUpRequireVerification({ requireVerification: true }));

        (window as any).umami.track('sign_up', { email });

        yield put(signUpData());
    } catch (error: any) {
        const errorSetup = {
            message: error.response.data.errors[0].errorMessage,
            code: error.response.status,
            codeConfig: error.response.data.errors[0].errorCode,
        };
        yield put(
            sendError({
                error: errorSetup,
                processingType: 'alert',
                extraOptions: {
                    actionError: signUpError,
                },
            }),
        );
    }
}
